import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { MenuIdCustomerExperiences } from '@jira/navigation-apps__constants/src/MenuIdCustomerExperiences.tsx';
import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getCustomerServiceL1NavigationResources } from '@jira/router-resources__customer-service-l1-navigation/src/getCustomerServiceL1NavigationResources.tsx';
import { csmExperienceEmailRoute } from '@jira/router-routes__help-center-settings-routes/src/csmExperienceEmailRoute.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { HelpCenterSettingsEmailAppEntryPoint as main } from '@jira/spa-apps__help-center-settings-email/src/HelpCenterSettingsEmailAppEntryPoint.entrypoint.tsx';

import { getCsmExperiencesResources } from './getCsmExperiencesResources.tsx';

const HelpCenterSettingsEmailEntryPoint: ReturnType<typeof createPageEntryPoint> =
	createPageEntryPoint({
		main,
	});

export const csmExperienceEmailRouteEntry: Route = createEntry(csmExperienceEmailRoute, () => ({
	group: 'helpcenter-settings',
	perfMetricKey: 'help-center-settings.csm-experience-email',
	layout: serviceProjectLayout,
	navigation: {
		menuId: MenuIdCustomerExperiences,
		sidebarId: SidebarIdCsmApp,
	},
	entryPoint() {
		return fg('csm_appification_standalone_navigation')
			? HelpCenterSettingsEmailEntryPoint
			: notFoundPageEntrypoint;
	},
	resources: [...getCustomerServiceL1NavigationResources(), ...getCsmExperiencesResources()],
	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
